// export const BaseIP = 'http://192.168.29.113:8091/';

export const BaseIP = 'https://registration.jainboardingsangli.com/';



export const MemberRegistration= BaseIP+ "api/member_logins/registerMember" //Member Registration

export const MemberLogin= BaseIP+ "api/member_logins/memberlogin" //Member Login

export const EducationMaster= BaseIP+ "api/education/select" //Education Master
export const SubeducationMaster= BaseIP+ "api/subeducation/select" //Education Master
export const subcastMaster= BaseIP+ "api/subcast/select" // SubCast master
export const IncomeMaster= BaseIP+ "api/income/select" // Income master
export const StateMaster= BaseIP+ "api/state/getState" // State master
export const DistrictMaster= BaseIP+ "api/district/getDistrict" // District master
export const TalukaMaster= BaseIP+ "api/taluka/getTaluka" // Taluka master

export const RegsitrationSave=BaseIP+"api/registration/save"// registrationSave
export const RegistrationUpdate=BaseIP+"api/registration/update" // checkbox api
export const RegistrationUpload=BaseIP+"api/registration/upload"//Upload api
export const RegistrationSelect=BaseIP+"api/registration/select"//Personal detail api
export const RegistrationUpdateProfile=BaseIP+"api/registration/update/profile"//Update
export const PaymentUpdate=BaseIP+"api/registration/payment"//payment Update

export const Forgetuser=BaseIP+"api/member_logins/forgotPassword"//Forgot Password
export const RegistrationStop=BaseIP+"api/locakDate/getlocakDate"//registration stop


// export const PaymentSuccessApi=BaseIP+"api/manual_payment/processPayment"//Payment Success 
export const receiptDataApi=BaseIP+"api/manual_payment/receiptdata"//Payment Receipt Data show 


export const PaymentAddApi=BaseIP+"api/payment/processPayment/none"//Payment Success Add For Wido

// ==========NEW PAYMENT API's
export const PaymentAdd=BaseIP+"api/manual_payment/add"  // Payment Add API (POST)





// ==================Admin BarCode=========
export const QrAdminLogin=BaseIP+"api/attendance/adminlogin"
export const EntryDetail=BaseIP+"api/attendance/list"

export const BarCodeRecipt=BaseIP+"api/attendance/barcode"
export const BarCodeScanningPerson=BaseIP+"api/attendance/attendanceDetails"
export const Getattendancedata=BaseIP+"api/attendance/getRegId"
export const selectregdataforsacn=BaseIP+"api/registration/select/scan"
export const BarcodeScanPage=BaseIP+"api/registration/select/list"



